<nav class="navbar navbar-expand-lg navbar-light sticky-top">
    <a class="navbar-brand" href="#home"><img src="assets/img/logo.webp" alt="Logo"></a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item"><a class="nav-link" href="#discoverMicroMock">{{ 'DiscoverMicromockHeader' | translate
                    }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#usecases">{{ 'UsecasesHeader' | translate }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#configurationMicroMock">{{ 'ConfigurationMicroMock' |
                    translate }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#heroAIAssistant">{{ 'AIAssistant' | translate }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#beneficiMicromock">{{ 'BenefitsMicromock' | translate }}</a>
            </li>
            <li class="nav-item"><a class="nav-link" href="#architecture">{{ 'Architecture' | translate }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#roadmap">{{ 'Roadmap' | translate }}</a></li>
            <li class="nav-item"><a class="nav-link" href="#futureFeatures">{{ 'FutureFeatures' | translate }}</a></li>

        </ul>
    </div>
    <div class="language-switcher">

        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" (click)="switchLanguage('en')"
            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.2 38.4"
            style="enable-background:new 0 0 55.2 38.4" xml:space="preserve" class="flag-icon">
            <style type="text/css">
                .st0 {
                    fill: #FEFEFE;
                }

                .st1 {
                    fill: #C8102E;
                }

                .st2 {
                    fill: #012169;
                }
            </style>
            <g>
                <path class="st0"
                    d="M2.87,38.4h49.46c1.59-0.09,2.87-1.42,2.87-3.03V3.03c0-1.66-1.35-3.02-3.01-3.03H3.01 C1.35,0.01,0,1.37,0,3.03v32.33C0,36.98,1.28,38.31,2.87,38.4L2.87,38.4z" />
                <polygon class="st1"
                    points="23.74,23.03 23.74,38.4 31.42,38.4 31.42,23.03 55.2,23.03 55.2,15.35 31.42,15.35 31.42,0 23.74,0 23.74,15.35 0,15.35 0,23.03 23.74,23.03" />
                <path class="st2" d="M33.98,12.43V0h18.23c1.26,0.02,2.34,0.81,2.78,1.92L33.98,12.43L33.98,12.43z" />
                <path class="st2" d="M33.98,25.97V38.4h18.35c1.21-0.07,2.23-0.85,2.66-1.92L33.98,25.97L33.98,25.97z" />
                <path class="st2" d="M21.18,25.97V38.4H2.87c-1.21-0.07-2.24-0.85-2.66-1.94L21.18,25.97L21.18,25.97z" />
                <path class="st2" d="M21.18,12.43V0H2.99C1.73,0.02,0.64,0.82,0.21,1.94L21.18,12.43L21.18,12.43z" />
                <polygon class="st2" points="0,12.8 7.65,12.8 0,8.97 0,12.8" />
                <polygon class="st2" points="55.2,12.8 47.51,12.8 55.2,8.95 55.2,12.8" />
                <polygon class="st2" points="55.2,25.6 47.51,25.6 55.2,29.45 55.2,25.6" />
                <polygon class="st2" points="0,25.6 7.65,25.6 0,29.43 0,25.6" />
                <polygon class="st1" points="55.2,3.25 36.15,12.8 40.41,12.8 55.2,5.4 55.2,3.25" />
                <polygon class="st1" points="19.01,25.6 14.75,25.6 0,32.98 0,35.13 19.05,25.6 19.01,25.6" />
                <polygon class="st1" points="10.52,12.81 14.78,12.81 0,5.41 0,7.55 10.52,12.81" />
                <polygon class="st1" points="44.63,25.59 40.37,25.59 55.2,33.02 55.2,30.88 44.63,25.59" />
            </g>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.77 63.15" (click)="switchLanguage('it')" title="Italian"
            class="flag-icon">
            <g fill-rule="nonzero">
                <path fill="#009246"
                    d="M29.47 0v63.15H4.99C2.24 63.15 0 60.9 0 58.16V4.99C0 2.24 2.24 0 4.99 0h24.48z" />
                <path fill="#fff" d="M61.31 0v63.15H29.47V0z" />
                <path fill="#CE2B37"
                    d="M61.31 63.15V0h24.48c2.74 0 4.98 2.24 4.98 4.99v53.17c0 2.74-2.24 4.99-4.98 4.99H61.31z" />
            </g>
        </svg>
    </div>
</nav>

<div id="knowingMicroMock" class="one-contact-area two-address-area mock1bg ptb-100">
    <div class="container">
        <div class="contact-content">
            <div class="one-section-title">
                <h2 style="color:black">{{ 'MicroMock' | translate }}</h2>
                <p>{{ 'MockMicroservices' | translate }}</p>
            </div>
        </div>
    </div>
</div>

<div id="discoverMicroMock" class="one-contact-area two-address-area mock2bg">
    <div class="container">
        <div class="contact-content" style="max-width: 580px;">
            <div class="one-section-title">
                <span class="sub-title">{{ 'DiscoverMicromockHeader' | translate }}</span>
                <h2 style="color: black;">{{ 'WhatIsMicroMock' | translate }}</h2>
                <p>{{ 'MicroMockDescription' | translate }}</p>
            </div>
        </div>
    </div>
</div>


<section id="usecases" class="one-service-area two-service-area ptb-100">
    <div class="container">
        <div class="one-section-title">
            <span class="sub-title">{{ 'PowerYourDevelopment' | translate }}</span>
            <h2>{{ 'UseCaseOrderGeneration' | translate }}</h2>
            <p>{{ 'UseCaseOrderGenerationDescription' | translate }}
                <span>{{ 'OrderService' | translate }}</span>, <span>{{ 'InventoryService' | translate }}</span> e
                <span>{{ 'PaymentService' | translate }}</span>.
                {{ 'OrderGenerationDescription2' | translate }}
                {{ 'OrderGenerationDescription3' | translate }}
                {{ 'OrderGenerationDescription4' | translate }}
            </p>
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-default active" id="nav-home-tab" data-bs-toggle="tab" href="#nav-home"
                    role="tab" aria-controls="nav-home" aria-selected="true">
                    <div class="service-item">
                        <i class='bx bxs-building-house'></i>
                        <span>{{ 'OrderService' | translate }}</span>
                    </div>
                </a>

                <a class="nav-item nav-default" id="nav-profile-tab" data-bs-toggle="tab" href="#nav-profile" role="tab"
                    aria-controls="nav-profile" aria-selected="false">
                    <div class="service-item">
                        <i class='bx bxs-dollar-circle'></i>
                        <span>{{ 'InventoryService' | translate }}</span>
                    </div>
                </a>

                <a class="nav-item nav-default" id="nav-contact-tab" data-bs-toggle="tab" href="#nav-contact" role="tab"
                    aria-controls="nav-contact" aria-selected="false">
                    <div class="service-item">
                        <i class='bx bxs-home-circle'></i>
                        <span>{{ 'PaymentService' | translate }}</span>
                    </div>
                </a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="service-advisor card-shadow">
                    <div class="row align-items-center d-flex justify-content-center">
                        <div class="col-lg-3">
                            <div class="advisor-img">
                                <img class="rounded-border half-width" src="assets/img/home-two/order-flow.png"
                                    alt="Advisor">
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="advisor-content">
                                <h2>{{ 'OrderService' | translate }}</h2>
                                <p> {{ 'OrderServiceSteps' | translate }} <span>{{ 'InventoryService' | translate
                                        }}</span> {{ 'And' | translate }}
                                    <span>{{ 'PaymentService' | translate }}</span> {{ 'OrderServiceSteps2' | translate
                                    }}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <div class="service-advisor card-shadow">
                    <div class="row align-items-center d-flex justify-content-center">
                        <div class="col-lg-3">
                            <div class="advisor-img">
                                <img class="rounded-border half-width" src="assets/img/home-two/inventory-service.webp"
                                    alt="Advisor">
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="advisor-content">
                                <h2>{{ 'InventoryService' | translate }}</h2>
                                <p>{{ 'InventoryServiceSteps' | translate }} <span>{{ 'OrderService' | translate
                                        }}</span> {{ 'InventoryServiceSteps2' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                <div class="service-advisor card-shadow">
                    <div class="row align-items-center d-flex justify-content-center">
                        <div class="col-lg-3">
                            <div class="advisor-img">
                                <img class="rounded-border half-width" src="assets/img/home-two/payment-service.webp"
                                    alt="Advisor">
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="advisor-content">
                                <h2>{{ 'PaymentService' | translate }}</h2>
                                <p> <span>{{ 'OrderService' | translate }}</span> {{ 'PaymentServiceSteps2' | translate
                                    }}
                                    {{ 'PaymentServiceSteps3' | translate }} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="usecasecomparison" class="one-service-area two-service-area">
    <div class="two-address-area ghostwhitebg pt-100">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ 'OptimizeProcesses' | translate }}</span>
                <h2>{{ 'ClassicTestsDetails' | translate }}</h2>
            </div>
            <div class="row">
                <div class="col-lg-6 d-flex">
                    <div class="custom-card">
                        <div class="address-item">
                            <h3>{{ 'ClassicTests' | translate }}</h3>
                            <img src="assets/img/home-two/usecase1ghostwhite.png" height="460" alt="Address">
                        </div>
                        <div class="container advisor-content">
                            <ul class="nobullets">
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails1' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails2' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails3' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails4' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails5' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails6' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'ClassicTestsDetails7' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 d-flex">
                    <div class="custom-card">
                        <div class="address-item">
                            <h3>{{ 'MicroMockTests' | translate }}</h3>
                            <img src="assets/img/home-two/usecase2ghostwhite.png" height="460" alt="Address">
                        </div>
                        <div class="container advisor-content">
                            <ul class="nobullets">
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails' | translate }}</li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails1' | translate }}
                                </li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails2' | translate }}
                                </li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails3' | translate }}
                                </li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails4' | translate }}
                                </li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails5' | translate }}
                                </li>
                                <li><i class='bx bxs-chevrons-right'></i> {{ 'MicromockTestsDetails6' | translate }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="configurationMicroMock" class="one-help-area two-help-area emerald-background">
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-lg-10 p-0">
                <div class="help-item help-item-bigger">
                    <div class="one-section-title">
                        <span class="sub-title">{{ 'CustomizeYourMock' | translate }}</span>
                        <h2>{{ 'MicromockCustomization' | translate }}</h2>
                        <p class="nomargin"> {{ 'MicromockCustomizationDetails' | translate }}</p>
                    </div>

                    <ul>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-network-chart'></i> <!-- Updated icon for Workspaces -->
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Workspaces' | translate }}</h3>
                                <p class="p-80">{{ 'WorkspacesDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-layer'></i> <!-- Updated icon for Applications -->
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Microservices' | translate }}</h3>
                                <p class="p-80">{{ 'MicroservicesDetails' | translate }}
                                    <span>{{ 'InventoryMock' | translate }}</span> {{ 'And' | translate }} <span>{{
                                        'PaymentMock' | translate }}</span>.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-transfer-alt'></i> <!-- Updated icon for Transports -->
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Transports' | translate }}</h3>
                                <p class="p-80"> {{ 'TransportsDetails' | translate }} {{ 'TransportsDetails2' |
                                    translate }} <span>{{ 'InventoryMock' | translate }}</span> {{ 'TransportsDetails3'
                                    | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-message-rounded-check'></i> <!-- Updated icon for Responses -->
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Responses' | translate }}</h3>
                                <p class="p-80">{{ 'ResponsesDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-play-circle'></i> <!-- Updated icon for Producers -->
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Producers' | translate }}</h3>
                                <p class="p-80">{{ 'ProducersDetails' | translate }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 p-0">
                <div class="help-img-two bit-tornado-bg">
                </div>
            </div>
        </div>
    </div>
</section>


<section id="heroAIAssistant" class="one-help-area ptb-25">
    <div class="row">

        <div class="col-4">
            <img style="border-radius: 50%; max-width: 75%; padding-top: 50%; margin-bottom: 40%; margin-left:12%;"
                src="assets/img/home-two/heroAIAssistant.webp" alt="AI Hero Assistant">
        </div>
        <div class="col-8">
            <div class="container">
                <div class="help-item" style="max-width: 80% !important;">
                    <div class="one-section-title w-100">
                        <span class="sub-title">{{ 'AIAssistantSupport' | translate }}</span>
                        <h2>{{ 'AIHeroAssistant' | translate }}</h2>
                        {{ 'AIAssistantDetails' | translate }}<br />
                        {{ 'AIAssistantDetails2' | translate }}
                        <hr />
                        {{ 'AIAssistantDetails3' | translate }}
                    </div>
                    <ul>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-brain'></i>
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Customization' | translate }}</h3>
                                <p>{{ 'CustomizationDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-cog'></i>
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Mappings' | translate }}</h3>
                                <p>{{ 'MappingsDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-code-block'></i>
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'Template' | translate }}</h3>
                                <p>{{ 'TemplateDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-compass'></i>
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'ModelCongruity' | translate }}</h3>
                                <p>{{ 'ModelCongruityDetails' | translate }}</p>
                            </div>
                        </li>
                        <li>
                            <div class="help-icon">
                                <i class='bx bx-bolt-circle'></i>
                            </div>
                            <div class="help-inner">
                                <h3>{{ 'SimulatedData' | translate }}</h3>
                                <p>{{ 'SimulatedDataDetails' | translate }}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="one-section-title">
                        <h3 style="color:white !important;">{{ 'DataSecurity' | translate }}</h3>
                        {{ 'DataSecurityDetails' | translate }}
                        <br />
                        {{ 'DataSecurityDetails2' | translate }}
                        <br />
                        {{ 'DataSecurityDetails3' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div id="beneficiMicromock" class="four-expect-area ptb-25">
    <div class="container">
        <div class="one-section-title three-section-title">
            <span class="sub-title">{{ 'WhyMicromock' | translate }}</span>
            <h2>{{ 'MicromockBenefits' | translate }}</h2>
        </div>

        <div class="row d-flex">
            <div class="col-sm-6 col-lg-6 d-flex flex-wrap">
                <div class="expect-item">
                    <div class="expect-icon">
                        <i class='bx bx-code-alt'></i>
                    </div>
                    <div class="box">
                        <h3>{{ 'ForDevelopers' | translate }}</h3>
                        <ul>
                            <li><i class='bx bx-task'></i>{{ 'ForDevelopersDetails' | translate }}</li>
                            <li><i class='bx bx-refresh'></i>{{ 'ForDevelopersDetails1' | translate }}</li>
                            <li><i class='bx bx-share-alt'></i>{{ 'ForDevelopersDetails2' | translate }}</li>
                            <li><i class='bx bx-repeat'></i>{{ 'ForDevelopersDetails3' | translate }}</li>
                            <li><i class='bx bx-laptop'></i>{{ 'ForDevelopersDetails4' | translate }}</li>
                            <li><i class='bx bx-timer'></i>{{ 'ForDevelopersDetails5' | translate }}</li>
                            <li><i class='bx bx-code'></i>{{ 'ForDevelopersDetails6' | translate }}</li>
                            <li><i class='bx bx-cog'></i>{{ 'ForDevelopersDetails7' | translate }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-6 d-flex flex-wrap">
                <div class="expect-item">
                    <div class="expect-icon">
                        <i class='bx bx-check-shield'></i>
                    </div>
                    <div class="box">
                        <h3>{{ 'ForQA' | translate }}</h3>
                        <ul>
                            <li><i class='bx bx-share-alt'></i>{{ 'ForQADetails' | translate }}</li>
                            <li><i class='bx bx-edit'></i>{{ 'ForQADetails1' | translate }}</li>
                            <li><i class='bx bx-refresh'></i>{{ 'ForQADetails2' | translate }}</li>
                            <li><i class='bx bx-shield-quarter'></i>{{ 'ForQADetails3' | translate }}</li>
                            <li><i class='bx bx-check-circle'></i>{{ 'ForQADetails4' | translate }}</li>
                            <li><i class='bx bx-cog'></i>{{ 'ForQADetails5' | translate }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-6 d-flex flex-wrap">
                <div class="expect-item">
                    <div class="expect-icon">
                        <i class='bx bx-building'></i>
                    </div>
                    <div class="box">
                        <h3>{{ 'ForCompany' | translate }}</h3>
                        <ul>
                            <li><i class='bx bx-standard'></i>{{ 'ForCompanyDetails' | translate }}</li>
                            <li><i class='bx bx-timer'></i>{{ 'ForCompanyDetails1' | translate }}</li>
                            <li><i class='bx bx-error'></i>{{ 'ForCompanyDetails2' | translate }}</li>
                            <li><i class='bx bx-server'></i>{{ 'ForCompanyDetails3' | translate }}</li>
                            <li><i class='bx bx-cog'></i>{{ 'ForCompanyDetails4' | translate }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-6 d-flex flex-wrap">
                <div class="expect-item">
                    <div class="expect-icon">
                        <i class='bx bx-group'></i>
                    </div>
                    <div class="box">
                        <h3>{{ 'ForTeam' | translate }}</h3>
                        <ul>
                            <li><i class='bx bx-share-alt'></i>{{ 'ForTeamDetails' | translate }}</li>
                            <li><i class='bx bx-time'></i>{{ 'ForTeamDetails1' | translate }}</li>
                            <li><i class='bx bx-check'></i>{{ 'ForTeamDetails2' | translate }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section id="architecture" class="one-help-area ptb-25">
    <div class="one-section-title three-section-title">
        <span class="sub-title">{{ 'ArchitectureOverview' | translate }}</span>
        <h2 style="color:white !important;">{{ 'ArchitectureTitle' | translate }}</h2>
    </div>
    <div class="two-house-area pb-70">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-layout'></i>
                        </div>
                        <h3>{{ 'MicromockUI' | translate }}</h3>
                        <p>{{ 'UIImplementation' | translate }}<br />
                            {{ 'UIPerks' | translate }}
                        </p>
                        <div class="box">
                            <ul>
                                <li><i class='bx bx-layer'></i>{{ 'UIPerksDetails' | translate }}</li>
                                <li><i class='bx bx-sync'></i>{{ 'UIPerksDetails1' | translate }}</li>
                                <li><i class='bx bx-cube'></i>{{ 'UIPerksDetails2' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-network-chart'></i>
                        </div>
                        <h3>{{ 'MicromockService' | translate }}</h3>
                        <p> {{ 'MicromockServiceDetails' | translate }}<br /> {{ 'MicromockServiceDetails1' | translate
                            }}
                        </p>
                        <div class="box">
                            <ul>
                                <li><i class='bx bx-play'></i>{{ 'MicromockServiceDetails2' | translate }}</li>
                                <li><i class='bx bx-down-arrow-circle'></i>{{ 'MicromockServiceDetails3' | translate }}
                                </li>
                                <li><i class='bx bx-upload'></i>{{ 'MicromockServiceDetails4' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-archive-in'></i>
                        </div>
                        <h3>{{ 'Install' | translate }}</h3>
                        <p>{{ 'InstallHeader' | translate }}
                        </p>
                        <div class="box">
                            <ul>
                                <li><i class='bx bx-desktop'></i>{{ 'InstallDetails' | translate }}</li>
                                <li><i class='bx bx-laptop'></i>{{ 'InstallDetails1' | translate }}</li>
                                <li><i class='bx bx-server'></i>{{ 'InstallDetails2' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="roadmap" class="three-process-area pb-100 ptb-25">
    <div class="container-fluid">
        <div class="one-section-title">
            <span class="sub-title">{{ 'PlanningRoadmapDescription' | translate }}</span>
            <h2>{{ 'RoadmapTitle' | translate }}</h2>
            <p>
                {{ 'RoadmapDescription' | translate }}
            </p>
            <p>
                {{ 'RoadmapDescription1' | translate }}
            </p>
        </div>

        <div>
            <div class="milestone" *ngFor="let milestone of milestones; let i = index"
                [attr.data-number]="milestone.number">
                <div class="milestone-content">
                    <h5>{{ getDateRange(milestone) }}</h5>
                    <p>{{ getDescription(milestone) }}</p>
                </div>
            </div>
<svg id="evy9HYhEabT1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 802 250" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" project-id="f387b885a6034f1ba83b5af9584e9565" export-id="069ff069166a4649a85f2faf8dc9cb9d" cached="false"><g transform="matrix(.686833 0 0 0.686831 60.507748-6.699006)"><path d="M66.540743,61.423933c87.459251,0,100.797385,3.118465,100.797385,119.210209q0,116.091743,90.062205,109.844653" transform="translate(-13.830051 1.536669)" fill="none" stroke="#290657" stroke-width="1.604"/><path d="M68.131905,61.873617c87.459251,0,99.206223,2.668781,99.206223,118.760525q0,116.091743,89.793777,109.61199" transform="matrix(.999998-.002157 0.002157 0.999998 332.484044 1.421446)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M78.199202,62.329579c87.459251,0,98.258051,2.212819,98.258051,118.304563q0,116.091743,89.793777,109.61199" transform="matrix(.986005-.001313 0.001332 0.999998 676.947907-.165283)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M66.540743,61.423933c87.459251,0,100.797385,3.118465,100.797385,119.210209q0,116.091743,90.062205,109.844653" transform="matrix(-1.044184 0 0 1 494.699513 1.536669)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M66.540743,61.423933c87.459251,0,100.797385,3.118465,100.797385,119.210209q0,116.091743,84.244165,110.394969" transform="matrix(-1.044184 0 0 1 842.698205 0.536669)" paint-order="markers fill stroke" fill="none" stroke="#777" stroke-width="1.604"/><path d="M109.999999,50c40,0,60,30,60,110" transform="translate(.000001 0)" fill="none" stroke="#290657" stroke-width="1.604"/><path d="M109.999999,50c40,0,60,30,60,110" transform="translate(696.34319 2.960603)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M109.999999,50c40,0,60,30,60,110" transform="translate(345.465315 0)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M109.999999,50c40,0,60,30,60,110" transform="matrix(-1.329871 0 0 1 527.470577 0)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M109.999999,50c40,0,60,30,60,110" transform="matrix(-1.329871 0 0 1 878.838451 0)" fill="none" stroke="#777" stroke-width="1.604"/><ellipse rx="10" ry="10" transform="translate(60.169052 62.960602)" fill="#191129"/><ellipse rx="10" ry="10" transform="translate(235.926204 291.333117)" fill="#290657" stroke="#290657"/><ellipse rx="10" ry="10" transform="translate(590 291.333117)" fill="#777"/><ellipse rx="10" ry="10" transform="translate(767.5853 61.960602)" fill="#777"/><ellipse rx="10" ry="10" transform="translate(931.315792 290.089436)" fill="#777"/><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(763.093107 67.977064)" fill="#fff" stroke-width="0"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
5
]]></tspan></text><ellipse rx="10" ry="10" transform="translate(415.218734 62.960602)" fill="#777"/><path d="M136,199.999999c2.736498,66.675621,30.293482,97.376329,64,101.333118" transform="translate(4.367874 0.000001)" fill="none" stroke="#290657" stroke-width="1.604"/><path d="M136,199.999999q4,101.333118,64,101.333118" transform="translate(352.37723-1.104841)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M136,199.999999q4,101.333118,64,101.333118" transform="translate(704.167021-1.10484)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M136,199.999999q4,101.333118,64,101.333118" transform="matrix(-.930645 0 0 1 457.740868 0)" fill="none" stroke="#777" stroke-width="1.604"/><path d="M136,199.999999q4,101.333118,64,101.333118" transform="matrix(-.930638 0.003713 0.00399 0.999992 806.830258-1.475418)" fill="none" stroke="#777" stroke-width="1.604"/><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(55.676827 68.574216)" fill="#fff" stroke-width="0"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
1
]]></tspan></text><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(231.433846 296.92416)" fill="#fff" stroke-width="0"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
2
]]></tspan></text><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(410.726283 68.574217)" fill="#fff" stroke-width="0"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
3
]]></tspan></text><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(585.507765 296.929495)" fill="#fff" stroke-width="0"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
4
]]></tspan></text><text dx="0" dy="0" font-family="&quot;evy9HYhEabT1:::Roboto&quot;" font-size="16" font-weight="400" transform="translate(926.823022 295.343997)" fill="#fff"><tspan y="0" font-weight="400" stroke-width="0"><![CDATA[
6
]]></tspan></text></g>
<style><![CDATA[
@font-face {font-family: 'evy9HYhEabT1:::Roboto';font-style: normal;font-weight: 400;src: url(data:font/ttf;charset=utf-8;base64,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) format('truetype');}
]]></style>
</svg>



        </div>
    </div>
</section>

<section id="futureFeatures" class="three-process-area pt-25">
    <div class="process-style-area ptb-25">
        <div class="container">
            <div class="main-section-title">
                <span class="sub-title">{{ 'FeaturesToIntegrate' | translate }}</span>
                <h2>{{ 'FutureFeaturesToIntegrate' | translate }}</h2>
            </div>

            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="process-style-accordion">
                        <div class="accordion" id="ProcessAccordion">
                            <div class="accordion-item">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <span>01</span> {{ 'Electron' | translate }}
                                </button>
                                <div id="collapseOne" class="accordion-collapse collapse show"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'ElectronDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <span>02</span> {{ 'Kubernetes' | translate }}
                                </button>
                                <div id="collapseTwo" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'KubernetesDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <span>03</span>{{ 'AI' | translate }}
                                </button>
                                <div id="collapseThree" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'AIDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <span>04</span> {{ 'API' | translate }}
                                </button>
                                <div id="collapseFour" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'APIDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <span>05</span> {{ 'Test' | translate }}
                                </button>
                                <div id="collapseFive" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold"> {{ 'TestDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <span>06</span> {{ 'MessageBrokers' | translate }}
                                </button>
                                <div id="collapseSix" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'MessageBrokersDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <span>07</span> {{ 'MassiveData' | translate }}
                                </button>
                                <div id="collapseSeven" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'MassiveDataDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                    <span>08</span> {{ 'CloudSync' | translate }}
                                </button>
                                <div id="collapseEight" class="accordion-collapse collapse"
                                    data-bs-parent="#ProcessAccordion">
                                    <div class="accordion-body">
                                        <p class="bold">{{ 'CloudSyncDetails' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="process-style-image">
                        <img src="assets/img/home-two/lightningBulb.webp" alt="Creative ideas">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<footer class="one-footer-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <a href="#home"><img src="assets/img/logo-footer.webp" alt="Logo"></a>
                    <div class="footer-address">
                        <ul>
                            <li>
                                <i class='bx bx-phone-call'></i>
                                <a href="tel:+4498886660000">+39 055 343 64 64</a>
                            </li>
                            <li>
                                <i class='bx bx-message-square-detail'></i>
                                <a href="mailto:info@micromock.com">info&#64;micromock.ai</a>
                            </li>
                            <li>
                                <i class='bx bx-current-location'></i>
                                Via dei Colatori 10, Sesto Fiorentino (FI), 50019
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 flex-container">
                <h6>{{'PrivacyCookieTermsHeader' | translate}}</h6>
                <a href="https://www.iubenda.com/privacy-policy/51420807"
                    class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
                    title="Privacy Policy ">{{'PrivacyPolicy' | translate}}</a>
                <script
                    type="text/javascript">(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);</script>
                <a href="https://www.iubenda.com/privacy-policy/51420807/cookie-policy"
                    class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
                    title="Cookie Policy ">{{'CookiePolicy' | translate}}</a>
                <script
                    type="text/javascript">(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);</script>
                <a href="https://www.iubenda.com/termini-e-condizioni/51420807"
                    class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
                    title="Termini e Condizioni ">{{'TermsAndConditions' | translate}}</a>
                <script
                    type="text/javascript">(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);</script>
            </div>
        </div>

        <div class="copyright-area">
            <div class="row">
                <div class="col-lg-6">
                    <div class="copyright-item">
                        <p>© MicroMock, {{ 'PoweredBy' | translate }} <a href="https://vivido.it/"
                                target="_blank">Vivido</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
